import React from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'

import {
  getInventoryOrdersSortings,
  setInventoryOrderSortings,
} from '~/store/duck/inventoryOrders'

import SortingFilter from '../filters/SortingFilter'

const OrderedDateSortingFilter = () => {
  const { t } = useTranslation('Admin')
  const dispatch = useDispatch()
  const sortings = useSelector(getInventoryOrdersSortings)
  const sortKey = 'creationDate'

  const handleSort = (ascending: boolean) => {
    dispatch(setInventoryOrderSortings({ ...sortings, [sortKey]: ascending }))
  }

  return (
    <SortingFilter
      isAscending={sortings[sortKey]}
      label={t('Admin:CATALOG.ORDERS.ORDERED')}
      onSort={handleSort}
    />
  )
}

export default OrderedDateSortingFilter
